export default __webpack_public_path__ + "static/media/logo.d16ec5af.png";